import { cr, interact, URLS } from "fire-wind-water";
import { Lifecycle } from "./lifecycle";
import { initialize } from "../lifecycle/initialize";
import { onInit } from "../lifecycle/onInit";
import { afterView, afterImageLoad } from "../lifecycle/afterView";
import { $cmsData, settings } from "../common/setting";
import { component, template } from "../common/monitor";
import { $messageHover } from "../common/message";
import { scmsService } from "../services/site";
import * as $ from "jquery";
import { actionBrowse } from "../lifecycle/onInit/browse";

declare const $cz: any;
class Module {
  static isAfter = false;
  static isOnInit = false;

  isBoot = false;

  static Lifecycle: any = new Lifecycle();
  static isDesign: boolean = settings.isDesign;
  static isPreview: boolean = settings.isPreview;
  static $user: any = {};
  static pid = settings.isPreview ? (URLS.getURL("pid") || (URLS.getURL("des")?null : (window['siteParams'] ? window['siteParams'].pid:null))) : settings.pid;
  constructor() {
    window.addEventListener("beforeunload", () => {
      this.destroy();
      return 1;
    });
    window.addEventListener("unload", () => {
      this.destroy();
      return 1;
    });
    initialize();
  }

  module(s: string, a: any[]): any {
    Module.Lifecycle.create(s, a);
    return this;
  }

  bootstrap(s: string): any {
    Module.Lifecycle.bootstrap(s);
    if (this.isBoot) {
      if (Module.isOnInit) {
        Module.Lifecycle.transferKey(s, "skOnInit");
      }
      if (Module.isAfter) {
        afterView(() => {
          Module.Lifecycle.transferKey(s, "skAfterViewInit");
          Module.Lifecycle.transferKey(s, "skAfterViewChecked");
        }, false);
        afterImageLoad(() => {
          $cz.event("afterLoad");
          Module.Lifecycle.skAfterContentInit();
        });
      }
    } else {
      this.isBoot = true;
      Module.Lifecycle.skEventChange("initialize", 1);
      onInit(() => {
        Module.onInit();
      });
    }

    return this;
  }

  static onInit(): void {
    Module.isOnInit = true;
    Module.Lifecycle.skOnInit();
    Module.afterViewInit();
  }
  static getPageAuth(): void {
    const m = $sk.template.get();
    const param = {
      tenantId: settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null),
      moduleId: 36,
      sess: m.user.session || "",
      instanceId: settings.instanceId,
      siteId: settings.siteId,
      objectTyp: "栏目",
      menuId: settings.menuId || URLS.getURL("menuId"),
      objId: settings.pageId || URLS.getURL("pid") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].pid:null)),
    };
    scmsService.getPageAuth(param).subscribe((res) => {
      if (res && res.content.status !== 1) {
        window.location.href = settings.category === "1" ? settings.pcLongUrl : settings.wapLongUrl;
      }
    });
  }
  static afterViewInit(): void {
    if (!Module.isAfter) {
      if (!settings.isPreview) {
        afterView(() => {
          Module.afterView();
        }, false);
        Module.isAfter = true;
      } else {
        template(() => {
          if (Module.isAfter) {
            Module.Lifecycle.skOnDestroy();
          }
          afterView(() => {
            Module.afterView();
          }, true);
        });
        component(() => {
          Module.afterView();
        });
      }
    }
  }

  static afterView(): void {
    Module.Lifecycle.skOnChange();
    if (!Module.isAfter) {
      Module.Lifecycle.skAfterViewInit();
      Module.isAfter = true;
    }
    Module.Lifecycle.skAfterViewChecked();
    Module.Lifecycle.skUpdateView();
    afterImageLoad(() => {
      $cz.event("afterLoad");
      Module.Lifecycle.skAfterContentInit();
    });
    if (!this.isDesign) {
      this.getPageAuth();
      // this.getMenuList();
      //文章、文件详情页需要加载完详情之后再调用浏览
      const pageList = ["articleinfo", "fileinfo"];
      let isLoad = true;
      //链接转小写
      let href = window.location.href;
      href = href.toLowerCase();
      pageList.forEach((d) => {
        if (href.indexOf(d) > -1) {
          isLoad = false;
        }
      });
      if (isLoad) {
        actionBrowse();
      }
    }
  }
  static getMenuList(): void {
    const m = $sk.template.get();
    const param = {
      tenantId: settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null),
      siteId: settings.siteId,
      category: interact.isMobile ? 2 : 1,
      sess: m.user.session || null,
      isSave: !settings.isDesign && !URLS.getURL("preview") ? 1 : 0  // 正式访问的链接改成了预览的链接，正式访问时加参数isSave=1
    };
    scmsService.getMenuList(param).subscribe((res) => {
      if (res.result === 0) {
        const menuList = res.content.items;
        cr.each($cmsData.container, (item: { [label: string]: any }) => {
          cr.each(item, (d) => {
            if (d.type === "NAV") {
              if (this.isPreview) {
                cr.each(menuList, (m) => {
                  if (
                    [2, 3, 4, 6, 7].indexOf(parseInt(m.type, 10)) > -1 ||
                    m.linkType == "system"
                  ) {
                    m.link = `${m.href.url}?tid=${settings.tenantId}&sid=${settings.siteId}&cy=${settings.category}&pid=${m.href.pageId}&menuId=${m.id}&t=${settings.t}`;
                  }
                  // 设置栏目页面title、关键词、描述
                  if (m.id === URLS.getURL("menuId") && m.searchTitle) {
                    document.title = m.searchTitle;
                    // 页面keywords/ desc
                    const keyMeta = document.querySelector("meta[name='keywords']");
                    if (keyMeta && m.searchKeyword) {
                      keyMeta.setAttribute("content", m.searchKeyword);
                    }
                    const descMeta = document.querySelector("meta[name='description']");
                    if (descMeta && m.searchDesc) {
                      descMeta.setAttribute("content", m.searchDesc);
                    }
                  }
                  if (m.subItems) {
                    cr.each(m.subItems, (b) => {
                      if (
                        [2, 3, 4, 6, 7].indexOf(parseInt(b.type, 10)) > -1 ||
                        b.linkType == "system"
                      ) {
                        b.link = `${b.href.url}?tid=${settings.tenantId}&sid=${settings.siteId}&cy=${settings.category}&pid=${b.href.pageId}&menuId=${b.id}&t=${settings.t}`;
                      }
                      if (b.id === URLS.getURL("menuId") && b.searchTitle) {
                        document.title = b.searchTitle;
                        // 页面keywords/ desc
                        const keyMeta = document.querySelector("meta[name='keywords']");
                        if (keyMeta && b.searchKeyword) {
                          keyMeta.setAttribute("content", b.searchKeyword);
                        }
                        const descMeta = document.querySelector("meta[name='description']");
                        if (descMeta && b.searchDesc) {
                          descMeta.setAttribute("content", b.searchDesc);
                        }
                      }
                    });
                  }
                });
              }
              if (interact.isMobile) {
                if (d.historyContent.basic.style.type === "bottomNav") {
                  this.initWapBottomNavHtml(d.id, menuList, d.historyContent.style);
                } else {
                  this.initWapTopNavHtml(d.id, menuList, d.historyContent.style);
                }
              } else {
                this.initNavHtml(d.id, menuList, d.historyContent.style);
              }
              Module.Lifecycle.skUpdateView();
              // this.skUpdateView();
            }
          });
        });
      }
    });
  }
  // 动态处理PC导航html
  static initNavHtml(id, data, style): void {
    let html = "";
    cr.each(data, (r, index) => {
      if (r.isShowTitle && r.isShowTitle != "false" && r.isShowTitle != "0") {
        // 拼接子菜单html
        let subUlHtml = "";
        if (r.subItems && r.subItems.length) {
          subUlHtml = '<ul class="nav-child">';
          cr.each(r.subItems, (sub, index) => {
            if (this.isDesign) {
              subUlHtml += `<li class="nav-item ${style.menu2.styleType == 'custom' ? style.menu2.fontSize : ''}"
                             style="${style.menu2.styleType == 'default' ? '' : 'color:'+style.menu2.color}">
                            <span class="nav-text">${sub.title}</span>
                          </li>`;
            } else if (sub.type == 2 || sub.type == 3 ||  sub.type == 4 || sub.type == 6 || sub.type == 7 ||
                (sub.type == 100 && (sub.linkType == 'custom' && sub.link || sub.linkType == 'system' && sub.href.url || sub.linkType == 'content' && sub.link))
            ) {
              subUlHtml += `<li class="nav-item ${style.menu2.styleType == 'custom' ? style.menu2.fontSize: ''}"
                             style="${style.menu2.styleType == 'default' ? '': 'color:'+style.menu2.color}">
                            <a class="goto-link" href="${sub.link}"  target=${sub.linkType == 'custom' ? '_blank' : ''}>
                              <span class="nav-text">${sub.title}</span>
                            </a>
                          </li>`;
            } else {
              subUlHtml += `<li class="nav-item ${style.menu2.styleType == 'custom' ? style.menu2.fontSize: ''}"
                             style="${style.menu2.styleType == 'default' ? '': 'color:'+style.menu2.color}">
                            <span class="nav-text">${sub.title}</span>
                          </li>`;
            }
          });
          subUlHtml += '</ul>';
        }
        if (this.isDesign) {
          html += `<li class="nav-item ${style.menu1.styleType == 'custom' ? style.menu1.fontSize: ''}"
                style="${style.menu1.styleType == 'default' ? '': 'color:'+style.menu1.color}">
                   <span class="nav-text">${r.title}</span>
                  ${subUlHtml}
                </li>`;
        } else if (r.type == 2 || r.type == 3 || r.type == 4 || r.type == 6 || r.type == 7 ||
              (r.type == 100 && (r.linkType == 'custom' && r.link || r.linkType == 'system' && r.href.url || r.linkType == 'content' && r.link))
        ) {
          html += `<li class="nav-item ${style.menu1.styleType == 'custom' ? style.menu1.fontSize: ''}"
                style="${style.menu1.styleType == 'default' ? '': 'color:'+style.menu1.color}">
                    <a class="goto-link" href="${r.link}" target=${r.linkType == 'custom' ? '_blank' : ''}>
                      <span class="nav-text">${r.title}</span>
                    </a>
                    ${subUlHtml}
               </li>`;
        }  else if ( r.linkType == 'anchor' && r.href.pageId) {
          html += `<li class="nav-item ${style.menu1.styleType == 'custom' ? style.menu1.fontSize: ''}"
                style="${style.menu1.styleType == 'default' ? '': 'color:'+style.menu1.color}">
                    <a class="goto-link" href="#${r.href.componentId}" sk-event.click="toAnchor('${r.href.componentId}')" >
                      <span class="nav-text">${r.title}</span>
                    </a>
                    ${subUlHtml}
               </li>`;
        } else {
          html += `<li class="nav-item ${style.menu1.styleType == 'custom' ? style.menu1.fontSize: ''}"
                style="${style.menu1.styleType == 'default' ? '': 'color:'+style.menu1.color}">
                  <span class="nav-text">${r.title}</span>
                  ${subUlHtml}
                </li>`;
        }
      }
    });
    $(`#NAV_${id} .nav-main .nav-ul`).html(html);
  }
  // 动态处理wap顶导航html
  static initWapTopNavHtml(id, data, style): void {
    let html = "";
    cr.each(data, (r, index) => {
      if (r.isShowTitle && r.isShowTitle != 'false' && r.isShowTitle != '0') {
        // 拼接子菜单html
        let subUlHtml = '';
        if (r.subItems &&r.subItems.length) {
          subUlHtml = '<ul class="nd-list-child">';
          cr.each(r.subItems, (sub, index) => {
            if (sub.isShowTitle && sub.isShowTitle != 'false' && sub.isShowTitle != '0') {
              if (this.isDesign) {
                subUlHtml += `<li class="nd-item ${style.menu2.styleType == 'custom' ? style.menu2.fontSize: ''}"
                             style="${style.menu2.styleType == 'default' ? '': 'color:'+style.menu2.color}">
                             <div class="nd-text">${sub.title}</div>
                          </li>`;

              } else if (sub.type == 2 || sub.type == 3 || sub.type == 4 || sub.type == 6 || sub.type == 7 ||
                  (sub.type == 100 && (sub.linkType == 'custom' && sub.link || sub.linkType == 'system' && sub.href.url))) {
                subUlHtml += `<li class="nd-item ${style.menu2.styleType == 'custom' ? style.menu2.fontSize: ''}"
                             style="${style.menu2.styleType == 'default' ? '': 'color:'+style.menu2.color}">
                              <div class="nd-text">
                                <a class="goto-link" href="${sub.link}"  target=${sub.linkType == 'custom' ? '_blank' : ''}>
                                    ${sub.title}
                                </a>
                               </div>
                          </li>`;
              } else {
                subUlHtml += `<li class="nd-item ${style.menu2.styleType == 'custom' ? style.menu2.fontSize: ''}"
                             style="${style.menu2.styleType == 'default' ? '': 'color:'+style.menu2.color}">
                             <div class="nd-text">${sub.title}</div>
                          </li>`;
              }
            }

          });
          subUlHtml += '</ul>';
        }
        if (this.isDesign) {
          html += `<li class="nd-item ${style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}"
                      style="${style.menu1.styleType == 'default' ? '' : 'color:' + style.menu1.color}">
                    <div class="nd-text">${r.title}
                        <div class="item-icon" sk-event.click="active(${index})"
                            style="${style.menu1.styleType == 'custom' ? 'border-color:'+style.menu1.color : ''};
                                    ${!r.subItems  || !r.subItems.length ? 'display: none' : '' }">
                       </div>
                   </div>
                  ${subUlHtml}
                </li>`;
        } else if (
            r.type == 2 || r.type == 3 || r.type == 4 || r.type == 6 || r.type == 7 ||
            (r.type == 100 && (r.linkType == 'custom' && r.link || r.linkType == 'system' && r.href.url))) {
          html += `<li class="nd-item ${style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}"
                    style="${style.menu1.styleType == 'default' ? '' : 'color:' + style.menu1.color}">
                    <div class="nd-text">
                       <a class="goto-link" href="${r.link}" target=${r.linkType == 'custom' ? '_blank' : ''}>
                        ${r.title}
                       </a>
                       <div class="item-icon" sk-event.click="active(${index})"
                            style="${style.menu1.styleType == 'custom' ? 'border-color:'+style.menu1.color : ''};
                                   ${!r.subItems  || !r.subItems.length ? 'display: none' : '' }">
                       </div>
                    </div>
                    ${subUlHtml}
               </li>`;
        } else {
          html += `<li class="nd-item ${style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}"
                        style="${style.menu1.styleType == 'default' ? '' : 'color:' + style.menu1.color}">
                   <div class="nd-text">${r.title}
                        <div class="item-icon" sk-event.click="active(${index})"
                            style="${style.menu1.styleType == 'custom' ? 'border-color:'+style.menu1.color : ''};
                                    ${!r.subItems  || !r.subItems.length ? 'display: none' : '' }">
                       </div>
                   </div>
                  ${subUlHtml}
                </li>`;
        }
      }
    });
    $(`#NAV_${id} .sk-nav-window .nd-nav .nd-list`).html(html);
  }
  // 动态处理wap底部导航html
  static initWapBottomNavHtml(id, data, style): void {
    let html = "";
    cr.each(data, (r, index) => {
      if (r.isShowTitle && r.isShowTitle != 'false' && r.isShowTitle != '0' && index < 4) {
        if (this.isDesign) {
          html += `<div class="nav-bottom-item ${this.pid == (r.href.pageId || '-1') ? 'active' : ''}"
                      style="${style.menu1.styleType == 'default' ? '' : 'color:' + style.menu1.color}">
                      <div class="icon">
                        <img class="icon-default" src="${r.icon ? r.icon : '../../assets/images/nav-icon.png'}" cms-smarket alt=""/>
                        <img class="icon-active" src="${r.iconActive ? r.iconActive : '../../assets/images/nav-icon-active.png'}" cms-smarket alt=""/>
                      </div>
                      <div class="title ${style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}"
                      style="${style.menu1.styleType == 'custom' ? 'color:'+ style.menu1.color : ''}">
                        ${r.title}
                      </div>
                    </div>`;
        } else if (
            r.type == 2 || r.type == 3 || r.type == 4 || r.type == 6 || r.type == 7 ||
            (r.type == 100 && (r.linkType == 'custom' && r.link || r.linkType == 'system' && r.href.url))) {
          html += `<div class="nav-bottom-item ${this.pid == (r.href.pageId || '-1') ? 'active' : ''}">
                       <a href="${r.link}" target="_self">
                          <div class="icon" >
                             <img class="icon-default" src="${r.icon ? r.icon : '../../assets/images/nav-icon.png'}" cms-smarket alt=""/>
                             <img class="icon-active" src="${r.iconActive ? r.iconActive : '../../assets/images/nav-icon-active.png'}" cms-smarket alt=""/>
                          </div>
                          <div class="title ${style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}"
                           style="${style.menu1.styleType == 'custom' ? 'color:'+ style.menu1.color : ''}"
                          > ${r.title}</div>
                       </a>
                   </div>`;
        } else {
          html += `<div class="nav-bottom-item ${this.pid == (r.href.pageId || '-1') ? 'active' : ''}">
                      <div class="icon" >
                         <img class="icon-default" src="${r.icon ? r.icon : '../../assets/images/nav-icon.png'}" cms-smarket alt=""/>
                         <img class="icon-active" src="${r.iconActive ? r.iconActive : '../../assets/images/nav-icon-active.png'}" cms-smarket alt=""/>
                      </div>
                      <div class="title ${style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}"
                       style="${style.menu1.styleType == 'custom' ? 'color:'+ style.menu1.color : ''}"
                      > ${r.title}</div>
                   </div>`;
        }
      }
    });
    $(`#NAV_${id} .bottomNav`).html(html);
  }
  destroy(): void {
    $messageHover({
      isShow: 0,
      top: 0,
      left: 0,
      scrollTop: 0,
      scrollLeft: 0,
    });
    const keys = Object.keys(Module.Lifecycle.modules);
    cr.each(keys, (d) => {
      this.remove(d);
    });
  }

  remove(s): void {
    Module.Lifecycle.skOnDestroy(s);
  }
}

export { Module };
